import { BaseTypeaheadModal } from '../../../../shared/views/typeaheads';
import { EquipmentTypeaheadItem } from '../EquipmentTypeaheadItem/view';

export const EquipmentModal = BaseTypeaheadModal.extend({
    template: '#tpl_sensor_equipment_typeahead_modal',
    itemView: EquipmentTypeaheadItem,
    toolbarnav_center_title: false,
    toolbarnav_title: function () {
        return _t('mobile_sensors_add_sensor');
    }
});
